"use client"

import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import CommonAuthLayout from "../common/common-auth-layout/CommonAuthLayout"
import SignupStepOne from "./SignupStepOne"
import SignupStepTwo from "./SignupStepTwo"
import CongratulationsPage from "./CongratulationsPage"
import SetupPage from "./SetupPage"
import "./SignupForm.css"
import { safeHotelSearchDisplayText } from "../../lib/utils/hotelSearchMappers"

const SignupForm = () => {

  const [redirectMessage, setRedirectMessage] = useState("")
  useEffect(() => {
    const message = sessionStorage.getItem("signup_redirect_message")

    if (message) {
      setRedirectMessage(message)
      sessionStorage.removeItem("signup_redirect_message")
    }
  }, [])
  const [currentStep, setCurrentStep] = useState(() => {
    return Number(sessionStorage.getItem("signup_current_step")) || 1
  })

  const [currentPage, setCurrentPage] = useState(() => {
    return sessionStorage.getItem("signup_current_page") || "signup"
  })

  const [stepOneData, setStepOneData] = useState({})
  const [completeFormData, setCompleteFormData] = useState({})

  const { data: onboardingData } = useSelector((state) => state.onboarding)
  const { events } = useSelector((state) => state.events)

  // restore step-1 data on refresh
  useEffect(() => {
    const saved = sessionStorage.getItem("signup_step_one_data")
    if (saved) {
      setStepOneData(JSON.parse(saved))
    }
  }, [])

  // Re-sync step from sessionStorage on mount so refresh on client (step 2) page keeps user on step 2
  useEffect(() => {
    const savedStep = sessionStorage.getItem("signup_current_step")
    if (savedStep) {
      const step = Number(savedStep)
      if (step === 2) {
        setCurrentStep(2)
      }
    }
  }, [])

  useEffect(() => {
    sessionStorage.setItem("signup_current_step", currentStep)
  }, [currentStep])

  useEffect(() => {
    sessionStorage.setItem("signup_current_page", currentPage)
  }, [currentPage])

  useEffect(() => {
    sessionStorage.setItem(
      "signup_step_one_data",
      JSON.stringify(stepOneData)
    )
  }, [stepOneData])

  // Clear signup session once user reaches setup preview
  useEffect(() => {
    if (currentPage === "setup") {
      sessionStorage.clear()
    }
  }, [currentPage])

  const handleStepOneComplete = (data) => {
    setStepOneData(data)
    setCurrentStep(2)
  }

  const handleStepTwoComplete = (fullData) => {
    setCompleteFormData(fullData)
    sessionStorage.removeItem("signup_step_two_data")
    setCurrentPage("congratulations")
  }

  const handleCongratulationsComplete = () => {
    setCurrentPage("setup")
  }

  if (currentPage === "congratulations") {
    return (
      <CongratulationsPage
        onComplete={handleCongratulationsComplete}
        onboardingData={onboardingData}
      />
    )
  }

  if (currentPage === "setup") {
    return (
      <SetupPage
        hotelName={safeHotelSearchDisplayText(completeFormData.property, { preferProperty: true }) || ""}
        onboardingData={onboardingData}
        events={events}
      />
    )
  }

  return (
    <CommonAuthLayout title="Join Us" showTitle={true}>
      {redirectMessage && (
        <div className="signup-alert">
          {redirectMessage}
        </div>
      )}
      {currentStep === 1 && (
        <SignupStepOne
          onNext={handleStepOneComplete}
          initialData={stepOneData}
        />
      )}

      {currentStep === 2 && (
        <SignupStepTwo
          onComplete={handleStepTwoComplete}
          stepOneData={stepOneData}
        />
      )}
    </CommonAuthLayout>
  )
}

export default SignupForm
